"use strict";
/**
 * Main entry point for the shortcode compiler
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageRenderer = exports.PageLexer = exports.ContentProvider = exports.ShortcodeRenderer = void 0;
exports.main = main;
// 导入您的TS包
// 例如: import { someFunction } from 'your-ts-package';
var shortcodeRenderer_1 = require("./shortcodeRenderer");
Object.defineProperty(exports, "ShortcodeRenderer", { enumerable: true, get: function () { return shortcodeRenderer_1.ShortcodeRenderer; } });
var contentProvider_1 = require("./contentProvider");
Object.defineProperty(exports, "ContentProvider", { enumerable: true, get: function () { return contentProvider_1.ContentProvider; } });
var pageLexer_1 = require("./pageLexer");
Object.defineProperty(exports, "PageLexer", { enumerable: true, get: function () { return pageLexer_1.PageLexer; } });
var pageRenderer_1 = require("./pageRenderer");
Object.defineProperty(exports, "PageRenderer", { enumerable: true, get: function () { return pageRenderer_1.PageRenderer; } });
/**
 * 主函数，用于测试您的TS包
 */
function main() {
    console.log('TS Package Testing Project');
    // 在这里使用您的TS包
    // 例如: const result = someFunction();
    // console.log('Result:', result);
}
// 如果直接运行此文件，则执行main函数
if (require.main === module) {
    main();
}
//# sourceMappingURL=index.js.map